import { Signer, TypedDataDomain, TypedDataField, getAddress } from "ethers";

export type LoginSignatureInput = {
  sid: string;
  walletAddress: string;
  domainName: string;
  domainVersion: string;
  chainId: number | bigint;
  verifyingContract: string;
};

export class EIP712AuthSigner {
  public static readonly primaryType = "Login";

  public static readonly types: Record<string, TypedDataField[]> = {
    Login: [
      { name: "sid", type: "string" },
      { name: "wallet", type: "address" },
    ],
  };

  public static buildDomain(input: LoginSignatureInput): TypedDataDomain {
    return {
      name: input.domainName,
      version: input.domainVersion,
      chainId: input.chainId,
      verifyingContract: getAddress(input.verifyingContract),
    };
  }

  public static buildMessage(input: LoginSignatureInput): { sid: string; wallet: string } {
    return {
      sid: input.sid,
      wallet: getAddress(input.walletAddress),
    };
  }

  public static async signLogin(signer: Signer, input: LoginSignatureInput): Promise<string> {
    if (!input.sid) {
      throw new Error("sid is required");
    }

    const domain = this.buildDomain(input);
    const message = this.buildMessage(input);

    return signer.signTypedData(domain, this.types, message);
  }
}
